import { render, staticRenderFns } from "./InternalDossiers.vue?vue&type=template&id=0cc2d98d&scoped=true"
import script from "./InternalDossiers.vue?vue&type=script&lang=js"
export * from "./InternalDossiers.vue?vue&type=script&lang=js"
import style0 from "./InternalDossiers.vue?vue&type=style&index=0&id=0cc2d98d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc2d98d",
  null
  
)

export default component.exports